import type { Network } from 'types';

export const apiHosts: {
  [key in Network]: string | undefined;
} = {
  local: undefined,
  bittensor_testnet: undefined,
  testnet: 'testnetapi.venus.io',
  mainnet: 'api.venus.io',
  'mainnet-preview': 'api-preview.venus.io',
};
